module.exports = __webpack_public_path__ + "static/media/rosa-icon.b221f23c.png";